var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconChevronRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 7 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.686,
  d: "m1.5 9.5 4-4-4-4"
})));
export default SvgIconChevronRight;